export default __webpack_public_path__ + "static/media/3.57516488.png";